import { ButtonBase, Typography } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import css from './styles.module.scss';
import EditIcon from '@material-ui/icons/Edit';

interface AddButtonProps {
    onClick?: () => any;
    className?: string;
    edit?: boolean;
    isCount?: boolean;
    counter?: any;
    disabled?: boolean;
}

export const AddButton: React.FC<AddButtonProps> = ({ disabled = false, className, onClick, children, edit, isCount, counter }) => {
    return (
        <>
            <ButtonBase onClick={onClick} className={classNames(css.module, className)} disabled={disabled}>
                <div className={css.buttonHeader}>
                    <div className={css.plusIcon} style={{ marginRight: children ? `8px` : `0px` }}>
                        {edit ? (
                            <span>
                                <EditIcon style={{ fontSize: '1.1rem', marginRight: children ? `8px` : `0px` }} />
                            </span>
                        ) : (
                            <span>+</span>
                        )}
                    </div>
                    <Typography className={css.graytext} variant={'body1'}>
                        {children}
                    </Typography>
                </div>
                <div className={css.buttonCount}>
                    {!isCount ? (
                        <div />
                    ) : (
                        <div className={css.counter}>
                            <Typography className={css.graytext} variant={'body1'}>
                                {counter ? `${counter}` : `0`}
                            </Typography>
                        </div>
                    )}
                </div>
            </ButtonBase>
        </>
    );
};
